export default function getRelevantImage(slug) {
  switch (slug) {
    case "strategy":
      return "https://data.whicdn.com/images/362459910/original.jpg";
    case "hidden-roles":
      return "https://thumbs.dreamstime.com/b/flat-lay-composition-vintage-detective-items-dark-wooden-background-flat-lay-composition-vintage-detective-items-177116240.jpg";
    case "dexterity":
      return "https://i.pinimg.com/736x/2c/1b/ca/2c1bca3237cea1dc49b2677ae0d645e4.jpg";
    case "push-your-luck":
      return "https://extrabetamerica.imgix.net/d02b4d481f8f451bbbe34a41c45c84c4.jpg?q=60&auto=format&fit=crop&ixlib=react-8.6.4&w=800";
    case "roll-and-write":
      return "https://i.etsystatic.com/16407439/r/il/9cfbd8/2462671123/il_fullxfull.2462671123_c4q4.jpg";
    case "deck-building":
      return "https://www.boardgamehalv.com/wp-content/uploads/2019/10/Dominion_DeckBuildingBoardGame_KnightCardClose-950x500.jpg";
    case "engine-building":
      return "https://data.whicdn.com/images/272486240/original.jpg";
  }
}
